import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ChiSono from "@/pages/ChiSono";
import Consulenze from "@/pages/Consulenze";
import Formazione from "@/pages/Formazione";
import Eventi from "@/pages/Eventi";
import News from "@/pages/News";
import Contatti from "@/pages/Contatti";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-center" richColors />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/chi-sono" element={<ChiSono />} />
              <Route path="/consulenze" element={<Consulenze />} />
              <Route path="/formazione" element={<Formazione />} />
              <Route path="/eventi" element={<Eventi />} />
              <Route path="/news" element={<News />} />
              <Route path="/contatti" element={<Contatti />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
